// extracted by mini-css-extract-plugin
module.exports = {"pulseBlob":"styles_pulseBlob__1PzPG","pulse-red":"styles_pulse-red__39qtq"};